import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaDiscord } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';

import {
  BannerWrapper,
  BannerContent,
  CloseButton,
  DiscordButton
} from './styles';

const bannerVariants = {
  hidden: {
    y: "100%",
    opacity: 0,
    transition: { type: 'spring', stiffness: 300, damping: 30 }
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: 'spring', stiffness: 100, delay: 0.2 }
  },
  exit: {
    y: "100%",
    opacity: 0,
    transition: { type: 'spring', stiffness: 300, damping: 30 }
  }
};

const DiscordInviteBanner = ({ isVisible, onClose, inviteLink }) => {
  const goToDiscord = () => {
    window.open(inviteLink, '_blank');
    onClose(); // Fecha o banner após clicar
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <BannerWrapper
          as={motion.div}
          variants={bannerVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <BannerContent>
            <FaDiscord size={24} style={{ marginRight: '15px', flexShrink: 0 }} />
            <div>
              <strong>Entre no nosso Discord!</strong>
              <p>Ganhe cupons, participe de sorteios e fique por dentro das novidades.</p>
            </div>
            <DiscordButton onClick={goToDiscord}>
              Entrar
            </DiscordButton>
          </BannerContent>
          <CloseButton onClick={onClose} aria-label="Fechar banner">
            <FiX />
          </CloseButton>
        </BannerWrapper>
      )}
    </AnimatePresence>
  );
};

export default DiscordInviteBanner; 